import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PartnershipEnquiryListLayer from "../components/PartnershipEnquiryListLayer";

const PartnershipEnquiryListPage = () => {
  return (
    <>
      <MasterLayout>
        <PartnershipEnquiryListLayer />
      </MasterLayout>
    </>
  );
};
export default PartnershipEnquiryListPage;
